exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ":root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n.Components-module__root__3DixO {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  max-width: 250px;\n  min-width: 150px;\n}\n.Components-module__field__3KIIo {\n  width: 100%;\n}\n.Components-module__error__aAJdV:not(:focus):not(.ant-select-focused) {\n  border: 1px solid #F7685B !important;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "Components-module__root__3DixO",
	"field": "Components-module__field__3KIIo",
	"error": "Components-module__error__aAJdV"
};